export default __webpack_public_path__ + "static/media/start-withdrawal.35880de5.svg";